export default "__VITE_ASSET__B6Km3mPG__"